
import SplitTruckTableView from "../components/truck/SplitTruckTableView.vue";
import SplitTruckView from "../components/truck/SplitTruckView.vue";
import Vue from "vue";
import Component from "vue-class-component";
import { SplitTruckSummary } from "../models/api/trucks/splitTrucks";
import TruckModule from "@/store/modules/truck";
import { getModule } from "vuex-module-decorators";
import notifications from "../lib/notifications";
import TrucksActions from "@/components/truck/TrucksActions.vue";

const truckModuleState = getModule(TruckModule);

@Component({
  components: {
    SplitTruckTableView,
    SplitTruckView,
    TrucksActions
  }
})
export default class TruckSummary extends Vue {
  summary: SplitTruckSummary = null;
  loading: boolean = true;
  saving: boolean = false;
  errorMessage: string = null;

  async created() {
    await this.prepareForSplit();
  }

  async prepareForSplit() {
    this.loading = true;
    try {
      this.summary = await truckModuleState.getSplitTruckSummary(+this.$route.params.idx);
    } catch (ex) {
      this.errorMessage = ex.response.data.message;
    }

    this.loading = false;
  }

  async split() {
    try {
      this.saving = true;
      const response = await truckModuleState.splitTruck();
      notifications.success("Split Truck", "Successfully split truck");
      this.$router.push({ path: `/trucks/${response.newTruckId}` });
    } catch (ex) {
      notifications.error("Split Truck", "Failed to split truck", ex);
    }

    this.saving = false;
  }

  async splitAndSplitAgain() {
    try {
      this.saving = true;
      await truckModuleState.splitTruck().then(() => {
        notifications.success("Split Truck", "Successfully split truck");
        this.prepareForSplit();
      });
    } catch (ex) {
      notifications.error("Split Truck", "Failed to split truck", ex);
    }

    this.saving = false;
  }

  cancel() {
    this.$router.back();
  }
}
